import { CircularProgress, Paper, Typography } from "@mui/material";
import React, { useEffect, useState, useCallback, useMemo } from "react";
import { ReactComponent as LineIcon } from "../../../../assets/svg/Line.svg";
import { formattedAmountWithoutAed } from "../../../../utils/CommonFunction";
import { formatAmountWithCurrency } from "../../../../utils/CurrencyUtils";
import styles from "./styles";
import { getApiData } from "../../../../utils/APIHelper";
import CircularStats from "./CircularStats";
import LinearStats from "./LinearStats";
import { ReactComponent as LargeDhiramIcon } from "../../../../assets/svg/LargeDhiramIcon.svg";

function Statistics() {
  const [summary, setSummary] = useState({});
  const [loading, setLoading] = useState(false);

  const getSummaryData = async () => {
    setLoading(true);
    try {
      const response = await getApiData(
        "api/project/analytics-dashboard",
        "GET",
        {},
        {},
        false
      );
      if (response?.success) {
        setSummary(response?.data || {});
      }
    } catch (error) {
      console.error("Something went wrong", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getSummaryData();
  }, []);

  const stats = useMemo(
    () => [
      {
        label: "Customers",
        value: summary?.total_customers ?? "---",
      },
      {
        label: "",
        value: <LinearStats summary={summary?.project_type_count} />,
      },
      {
        label: "",
        value: <CircularStats summary={summary} />,
      },
      {
        label: "Overall Amount",
        value: summary?.total_cost
          ? formatAmountWithCurrency(summary?.total_cost, "large")
          : "---",
      },
    ],
    [summary]
  );

  if (loading) {
    return (
      <center>
        <CircularProgress />
      </center>
    );
  }

  return (
    <div style={{ ...styles.rowFlex, padding: "0 1vw", marginBottom: "1vh" }}>
      {stats.map((stat, index) => (
        <div
          style={{
            height: "110px",
            width: index !== 1 ? "fit-content" : "40vw",
          }}
          key={index}
        >
          <Paper style={{ ...styles.stats_section, height: "100%" }}>
            {index !== 0 && <LineIcon />}
            <div
              style={{
                padding:
                  index === 0
                    ? "1vh 2vw 1vh 0vw"
                    : index === 1
                    ? "1vh 1.5vw"
                    : "1vh 3vw",
                width: index !== 1 ? "fit-content" : "100%",
              }}
            >
              <Typography style={styles.stats_label}>{stat.label}</Typography>
              <Typography
                style={{
                  ...styles.stats_value,
                  fontSize: (index === 0 || index === 3) && "26px",
                  marginTop: (index === 0 || index === 3) && "1.5vh",
                }}
              >
                {typeof stat.value === "number"
                  ? stat.value.toLocaleString()
                  : stat.value}
              </Typography>
            </div>
          </Paper>
        </div>
      ))}
    </div>
  );
}

export default Statistics;
